var SCM = SCM || {};

(function (ns, $) {
    
    ns.getSelectedCitations = function () {
        return $('.js-citation-checkbox:checked');
    };

    function selectAllNone(e) {
        SCM.CitationDownloadManager.setCheckboxesCheckedTo(this.checked);
        toggleEnabledForToolbarButtons();
        return false;
    }

    function removeSelected(e) {
        if (!ns.getSelectedCitations().length) return;
        var data = { 'citations': JSON.stringify(SCM.CitationDownloadManager.getSelectedCitationsData()) };
        $.ajax({
            type: 'POST',
            url: '/Citation/RemoveFromCitationManager',
            dataType: 'text',
            data: data
        }).done(function (response) {
            result = JSON.parse(response);
            if (result.Success) {
                window.location.reload();
            } else {
                console.warn('Could not remove citation(s). ' + response);
            }
        });
        return false;
    }

    function updatePromptNumber(e) {
        if (!ns.getSelectedCitations().length) return;
        var promptNumber = SCM.CitationDownloadManager.getSelectedCitationsData().length;
        var prompt = document.getElementById('js-prompt');
        if (!prompt) return false;
        prompt.textContent = promptNumber;
        return false;
    }

    function addListenerForQuerySelectorAll(eventName, selector, handler) {
        var items = document.querySelectorAll(selector);
        if (!items.length) return false;
        items.forEach(function (elem) {
            elem.addEventListener(eventName, handler);
        });
    }

    function itemCheckboxClicked(e) {
        toggleEnabledForToolbarButtons();

        if (this.classList.contains('js-select-all')) return;
        var selectAllCheckboxes = document.querySelectorAll('.js-select-all');
        if (!selectAllCheckboxes.length) return;
        if (!this.checked) {
            selectAllCheckboxes.forEach(function (elem) {
                elem.checked = false;
            });
        } else if (ns.getSelectedCitations().length === $('.js-citation-checkbox').length) {
            selectAllCheckboxes.forEach(function (elem) {
                elem.checked = true;
            });
        }
    }

    function toggleEnabledForToolbarButtons() {
        var $download = $('.js-download-selected');
        if (ns.getSelectedCitations().length) {
            $download.removeClass('disabled');
            $download.attr('data-reveal-id', 'getCitations');
            $('.js-remove-selected').removeClass('disabled');
        } else {
            $download.addClass('disabled');
            $download.attr('data-reveal-id', '');
            $('.js-remove-selected').addClass('disabled');
        }
    }

    ns.setCheckboxesCheckedTo = function (checked) {
        var elements = document.querySelectorAll('.js-citation-checkbox');
        if (!elements.length) return;
        elements.forEach(function (elem) {
            elem.checked = checked;
        });
        var selectAllCheckboxes = document.querySelectorAll('.js-select-all');
        if (!selectAllCheckboxes.length) return;
        selectAllCheckboxes.forEach(function (elem) {
            if (elem.checked !== checked) elem.checked = checked;
        });
    };

    ns.registerEventHandlers = function () {
        addListenerForQuerySelectorAll('click', '.js-citation-checkbox', itemCheckboxClicked);
        addListenerForQuerySelectorAll('click', '.js-select-all', selectAllNone);
        addListenerForQuerySelectorAll('click', '.js-remove-selected', removeSelected);
        addListenerForQuerySelectorAll('click', '.js-download-selected', updatePromptNumber);
    };

    ns.getSelectedCitationsData = function () {
        return ns.getSelectedCitations().map(function () {
            return {
                ResourceId: this.dataset.resourceid,
                ResourceType: this.dataset.resourcetype,
                AddedTime: this.dataset.addedtime,
                GeoRefId: this.dataset.georefid,
                CustomCitationUrl: this.dataset.customcitationurl
            };
        }).get();
    };

})(SCM.CitationDownloadManager = SCM.CitationDownloadManager || {}, jQuery);

(function ($) {
    $(function () {
        SCM.CitationDownloadManager.setCheckboxesCheckedTo(false);
        SCM.CitationDownloadManager.registerEventHandlers();
    });
})(jQuery);
